import React from 'react';

import EnhancedStepper from '@components/stepper/EnhancedStepper';
import { MAIN_THEME } from '@styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    margin: '20px 80px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 900px)': {
      justifyContent: 'center'
    }
  },
  stepper: {
    backgroundColor: 'transparent',
    width: '100%',
    '& .MuiStepLabel-root .Mui-active, .MuiStepLabel-root .Mui-completed': {
      color: MAIN_THEME.color.black
    },
    '@media only screen and (min-width: 600px)': {
      maxWidth: '1300px'
    }
  }
}));

export type AmendmentStatus = 'NEW' | 'IN_PROGRESS' | 'CONFIRMED' | 'CANCELLED';

type Props = {
  status: AmendmentStatus;
};

const StepperAtom: React.FC<Props> = ({ status }) => {
  const { classes } = useStyles();

  const steps = [
    'New',
    'In Progress',
    status === 'CANCELLED' ? 'Cancelled' : 'Confirmed'
  ];

  const activeStep = (() => {
    switch (status) {
      case 'NEW':
        return steps[0];
      case 'IN_PROGRESS':
        return steps[1];
      case 'CONFIRMED':
      case 'CANCELLED':
        return steps[2];
      default:
        return steps[0];
    }
  })();

  return (
    <EnhancedStepper
      steps={steps}
      activeStep={activeStep}
      className={classes.stepper}
      showStepperButton={false}
    />
  );
};

export { StepperAtom };
